import React, { useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import CustomCkeditor from "../../common/customeditor";
import * as faqService from "../../services/faq.services";
import Breadcrums from "../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
  FAQ_TYPES,
  SWAL_SETTINGS,
} from "../../../../utils/Constants";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";

const FaqAdd = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: 'FAQ',
      url: "/admin/cms/faq-management/faq/list/1",
    },
    { title: t("link_add"), url: "" },
  ];

  const validationSchema = Yup.object().shape({
      question : Yup.string().required(t("label_question_error")).test("no-spaces", "label_question_error", (value) => value.trim()),
      answer : Yup.string().required(t("label_answer_error")).test("no-spaces", "label_answer_error", (value) => value.trim()),
      type : Yup.string().required(t("label_type_error")).test("no-spaces", "label_type_error", (value) => value.trim()),
});



  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
     question : "",
     answer : "" , 
     type : FAQ_TYPES.APP_FEATURES
    },
    validateOnBlur: false,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      setSubmitted(true);
      let formData = new FormData();
      formData.append("question", values.question);
      formData.append("answer", values.answer);
      formData.append("type", values.type || FAQ_TYPES.APP_FEATURES); 

      faqService.Add(formData).then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            resetForm({ values: "" });
            navigate(`/admin/cms/faq-management/faq/list/1`);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
            setSubmitted(false);
            globalLoader(false);
          }
        })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    },
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    {t("link_add")} faq
                  </h6>
                </div>
                <div className="row row-sm">

                  <div className="col-md-12 text-center form-group">
                    <label htmlFor="question" className="text-left d-flex">
                      {t("label_question")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="question"
                      id="question"
                      type="text"
                      placeholder="Enter the your question"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.question}
                      className="form-control"
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="question" form={formik} />
                    </span>
                  </div>

                  <div className="col-md-12 text-center form-group d-none">
                          <label htmlFor="type" className="text-left d-flex">
                            {t("label_type")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              name="type"
                              id="type"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.type}
                              className="form-control" >

                              <option value="">{t("input_select_text")}</option>
                              {Object.values(FAQ_TYPES).map((value, i) => {
                                return (
                                  <option key={i} value={value}>
                                    {value
                                      .replace(/_/g, " ") // Replace underscores with spaces
                                      .toLowerCase() // Convert to lowercase
                                      .replace(/\b\w/g, (char) => char.toUpperCase())}{" "}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                      <CustomError name="type" form={formik} />
                    </span>
                        </div>

                  <div className="col-md-12 text-center form-group">
                    <label
                      htmlFor="answer"
                      className="text-left d-flex"
                    >
                      {t("label_answer")}:
                      <span className="requirestar">*</span>{" "}
                    </label>

                    <textarea
                      name="answer"
                      id="answer"
                      type="text"
                      placeholder="Enter the your answer"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.answer}
                      className="form-control"
                      rows={5}
                      /> 
                    <span className="text-danger d-flex text-left">
                      <CustomError name="answer" form={formik} />
                    </span>
                  </div>

                  <div className="mt-5">
                    <button
                      className="btn btn-info mr-2"
                      type="submit"
                      disabled={submitted ? true : null}
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_submit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      disabled={submitted ? true : null}
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default FaqAdd;
